var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/tabs/tabs.tsx";
const _excluded = ["children"],
      _excluded2 = ["index"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/web.dom-collections.iterator.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRect } from '@reach/rect';
import { Tabs as ReachTabs, TabList as ReachTabList, Tab as ReachTab, useTabsContext } from '@reach/tabs';
import classNames from 'clsx';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import Counter from '../counter/counter';
import './tabs.css';
const HORIZONTAL_PADDING = 8;
const AnimatedContext = /*#__PURE__*/React.createContext(null);

/** Tabs with a sliding active state. */
const AnimatedTabs = _ref => {
  let {
    children
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [activeRect, setActiveRect] = React.useState(null);
  const ref = React.useRef();
  const rect = useRect(ref); // @ts-ignore

  const top = (activeRect && activeRect.bottom) - (rect && rect.top); // @ts-ignore

  const width = activeRect && activeRect.width - HORIZONTAL_PADDING * 2; // @ts-ignore

  const left = (activeRect && activeRect.left) - (rect && rect.left) + HORIZONTAL_PADDING;
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(AnimatedContext.Provider, {
      value: setActiveRect,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 5
      }
    }, /*#__PURE__*/React.createElement(ReachTabs, _extends({}, rest, {
      // @ts-ignore
      ref: ref,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "w-full h-[3px] bg-primary-200 dark:bg-primary-700 absolute",
      style: {
        top
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames('absolute h-[3px] bg-primary-500 transition-all duration-200', {
        'hidden': top <= 0
      }),
      style: {
        left,
        top,
        width
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 9
      }
    }), children))
  );
};

/** A single animated tab. */
const AnimatedTab = _ref2 => {
  let {
    index
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  // get the currently selected index from useTabsContext
  const {
    selectedIndex
  } = useTabsContext();
  const isSelected = selectedIndex === index; // measure the size of our element, only listen to rect if active

  const ref = React.useRef();
  const rect = useRect(ref, {
    observe: isSelected
  }); // get the style changing function from context

  const setActiveRect = React.useContext(AnimatedContext); // callup to set styles whenever we're active

  React.useLayoutEffect(() => {
    if (isSelected) {
      // @ts-ignore
      setActiveRect(rect);
    }
  }, [isSelected, rect, setActiveRect]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(ReachTab, _extends({
      ref: ref
    }, props, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 5
      }
    }))
  );
};
/** Structure to represent a tab. */


/** Animated tabs component. */
const Tabs = _ref3 => {
  let {
    items,
    activeItem
  } = _ref3;
  const defaultIndex = items.findIndex(_ref4 => {
    let {
      name
    } = _ref4;
    return name === activeItem;
  });
  const history = useHistory();

  const onChange = selectedIndex => {
    const item = items[selectedIndex];

    if (typeof item.action === 'function') {
      item.action();
    } else if (item.to) {
      history.push(item.to);
    }
  };

  const renderItem = (item, idx) => {
    const {
      name,
      text,
      title,
      count
    } = item;
    return /*#__PURE__*/React.createElement(AnimatedTab, {
      key: name,
      as: "button",
      role: "button" // @ts-ignore
      ,
      title: title,
      index: idx,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 148,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 156,
        columnNumber: 9
      }
    }, count ? /*#__PURE__*/React.createElement("span", {
      className: "absolute -top-2 left-full ml-1",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Counter, {
      count: count,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159,
        columnNumber: 15
      }
    })) : null, text));
  };

  return /*#__PURE__*/React.createElement(AnimatedTabs, {
    onChange: onChange,
    defaultIndex: defaultIndex,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ReachTabList, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 7
    }
  }, items.map((item, i) => renderItem(item, i))));
};

export default Tabs;